const DEVICES_UPDATED = (state, devices) => {
  state.devices = devices
}

const DEVICE_UPDATED = (state, device) => {
  state.device = device
}

export default {
  DEVICES_UPDATED,
  DEVICE_UPDATED,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/devices/mutations.js